export default __webpack_public_path__ + "static/media/BraveFaceOne.cc5132b0.jpg";